import type { ReactNode } from "react";

/**
 * The status vocabulary, design.md section 3 and its three rules of 2026-09-24.
 *
 * A badge is for what needs someone to act: a dot and a word, in a tone. What is normal is `Quiet`,
 * a grey word with no shape at all, so a page of healthy things reads as quiet and the one amber or
 * red item is the only thing that pulls. The word always carries the meaning and the tone never
 * does alone.
 */
export type Tone = "info" | "ok" | "warn" | "danger" | "brand" | "neutral";

export function Badge({
  tone = "neutral",
  plain = false,
  children,
  testId
}: {
  tone?: Tone;
  /** No dot. For a badge whose word is already a state, such as a date that has not passed. */
  plain?: boolean;
  children: ReactNode;
  testId?: string;
}) {
  const classes = ["badge", tone === "neutral" ? "" : `tone-${tone}`, plain ? "is-plain" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes} data-testid={testId}>
      {children}
    </span>
  );
}

export function Quiet({ children, testId }: { children: ReactNode; testId?: string }) {
  return (
    <span className="quiet" data-testid={testId}>
      {children}
    </span>
  );
}

/** plan.md section 14.6: what is internal carries its own mark, on the box itself. */
export function InternalTag() {
  return <span className="internal-tag">Internt</span>;
}
